import "../css/app.scss";
import Navigation from "./components/navigation";
import Scroll from "./components/scroll";


/** Global Components */

/** Bootstrap */

$(() => {
  // init global components

  const $nav = $('[data-nav="el"]');
  if($nav.length) {
    new Navigation($nav);
  }

  const $accordions = $('[data-accordions="el"]');
  if ($accordions.length) {
    import('./components/accordions').then(({ default:Accordions }) => {
          $accordions.each(function (i, element) {
      new Accordions($(element));
    });
    })

  }

  const $countdown = $('[data-countdown="el"]');
  if ($countdown.length) {
    import('./components/countdown').then(({ default: Countdown }) => {
      new Countdown($countdown);
    })
  }


  const $gallery = $('[data-gallery="el"]')
  if($gallery.length) {
  import ('./components/gallery').then(({ default: Gallery }) => {
    $gallery.each((i, el) => {
      new Gallery($(el));
    });
  });
}

  const $filter = $('[data-filter="el"]');

  if($filter.length) {
    import ('./components/filter').then(({ default: Filter }) => {
      new Filter($filter);
    });
  }

  	const $map = $('[data-map="el"]');

	if ($map.length) {
    import('./components/map').then(({ default: Map }) => {
      new Map($map);
    })
	}

    const $marquee = $('[data-marquee="el"]');
  if($marquee.length) {

    import ('./components/marquee').then(({ default:Marquee }) => {
      $marquee.each((i, el) => {
        new Marquee($(el));
      });
    });
  }



  const $scrollImages = $('[data-scroll="image"]');
	const $fadeIn = $('[data-scroll="fade-in"]');
	const $appear = $('[data-scroll="appear"]');
  const $rightToLeft = $('[data-scroll="rightToLeft"]');
	new Scroll($fadeIn, $scrollImages, $rightToLeft,$appear);

});
